import React from 'react';
import { RedirectData } from '@hooks/useChat';
import './PdfListOverlay.scss';
import { ChevronLeftIcon, ChevronRightIcon } from '@assets/icon';

interface PdfListOverlayProps {
  data: RedirectData;
  onClose: () => void;
}

const PdfListOverlay: React.FC<PdfListOverlayProps> = ({ data, onClose }) => {

  // Get title based on type
  const getTitle = () => {
    switch (data.type) {
      case 'tax_handbook':
        return 'Tra cứu sổ tay thuế';
      case 'lump_tax':
        return '60 ngày xóa bỏ thuế khoán';
      default:
        return data.commandName || 'Tài liệu';
    }
  };

  return (
    <div className="pdf-panel-fullscreen">
      <div className="pdf-panel-header">
        <button
          className="pdf-panel-back-btn"
          onClick={onClose}
        >
          <ChevronLeftIcon className="pdf-panel-back-arrow" />
          <span className="pdf-panel-title">{getTitle()}</span>
        </button>
      </div>
      <div className="pdf-panel-list-container">
        <div className="pdf-panel-card">
          {data.items.map((item, index) => (
            <div 
              key={index} 
              className="pdf-panel-item"
            >
              <button
                className="pdf-panel-item-header"
                onClick={() => window.open(item.uri, '_blank')}
              >
                <span className="pdf-panel-item-title">{item.title}</span>
                <ChevronRightIcon className="pdf-panel-item-arrow" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PdfListOverlay;
